import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { light_logo2 } from "../../assets";
import axiosInstance from "../../redux/helpers/axios";
import toast from "react-hot-toast";

/**
 * @author
 * @function ForgotPass
 **/

export const ResetPass = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [id, setId] = useState(location?.state);
  const [code, setCode] = useState("");
  const [pass, setPass] = useState("");

  const handleResetPass = async (e) => {
    e.preventDefault();
    const ids = toast.loading("Loading...");
    try {
      await axiosInstance.post(`/auth/dealer/reset-password`, {
        email: id,
        code: code,
        password: pass,
      });
      toast.success("Password reset success.", { id: ids });
      navigate("/auth/login");
    } catch (error) {
      const { data } = error?.response;
      toast.error(`${data?.msg}`, { id: ids });
    }
  };
  return (
    <div className="max-w-full mx-auto flex flex-col items-center justify-center min-h-screen lg:py-12 md:py-10 sm:py-8 bg-[#D2D1CA]">
      <header className="w-full">
        <div className="container mx-auto flex justify-center lg:mt-6 md:mt-4 sm:mt-2 lg:mb-12 md:mb-8 sm:mb-4">
          <Link
            to="/"
            title="WristLink : the global marketplace for luxury watches"
            aria-label="WristLink "
          >
            <img src={light_logo2} alt="WristLink " className="h-[200px]" />
          </Link>
        </div>
      </header>

      <main className="flex-grow lg:w-4/12 md:w-7/12 sm:w-10/12 mx-auto lg:p-12 md:p-8 sm:p-2.5 border border-primarylight bg-white rounded-lg">
        <h1 className="lg:text-3xl sm:text-2xl  mb-6">Reset Password</h1>

        <div
          className="notification alert alert-error mb-4 hidden"
          id="js-form-errors"
        >
          <div className="flex items-center">
            <i className="i-close icon-lg text-error"></i>
            <span className="mx-3">Error message goes here.</span>
          </div>
        </div>

        <form className="space-y-4" onSubmit={handleResetPass}>
          <div className="form-group">
            <label htmlFor="email" className="block text-sm font-medium">
              Email address
            </label>
            <input
              type="text"
              id="email"
              name="email"
              required
              disabled
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed focus:border-gray-300 focus:ring-0"
              placeholder="Enter your email"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="block text-sm font-medium">
              Verification Code
            </label>
            <input
              type="text"
              id="email"
              name="email"
              required
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
              placeholder="Enter verification code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="block text-sm font-medium">
              New Password
            </label>
            <input
              type="text"
              id="email"
              name="email"
              required
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
              placeholder="Enter new password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-black text-white rounded-md hover:bg-primary"
          >
            Submit
          </button>

          <div className="flex justify-center my-4">
            <span className="text-sm text-gray-500">Or</span>
          </div>

          {/* <div className="flex flex-col space-y-2">
              <button
                type="button"
                className="w-full flex items-center justify-center py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
              >
                <img
                  src="https://static.chrono24.com/images/icons/svg/google-logo.svg"
                  alt="Google"
                  className="mr-2"
                />
                Continue with Google
              </button>
              <button
                type="button"
                className="w-full flex items-center justify-center py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
              >
                <img
                  src="https://static.chrono24.com/images/icons/svg/apple-logo.svg"
                  alt="Apple"
                  className="mr-2"
                />
                Continue with Apple
              </button>
            </div> */}
        </form>

        <p className="mt-4 text-sm text-gray-500">
          New to WristLink ?{" "}
          <Link
            to="/dealer-info/subcription-plan"
            className="text-black  hover:text-primary underine"
          >
            Become a Member
          </Link>
        </p>
      </main>

      <footer className="w-full mt-12">
        <div className=" lg:mx-auto md:mx-auto sm:mx-4 lg:text-[16px] md:text-[14px] sm:text-[10px] flex justify-center lg:space-x-4 md:space-x-2 sm:space-x-1">
          <Link to="/privacy-policy" className=" text-black  hover:text-white">
            Privacy Policy
          </Link>

          <Link to="/contact-us" className=" text-black  hover:text-primary">
            Contact
          </Link>
        </div>
      </footer>
    </div>
  );
};
